export interface StockAtDateReportSearch {
  productTypeId: string;
  stockAtDate: Date;
  search: string;
}
